export const countryPhoneCodes = [
    { label: "+506", value: "506" },    // Costa Rica
    { label: "+1", value: "1" },        // Estados Unidos / Canadá / Puerto Rico
    { label: "+7", value: "7" },        // Rusia y algunos territorios de América (casos raros)
    { label: "+20", value: "20" },      // Egipto (no aplica en América, lo puedes omitir si querés)
    { label: "+52", value: "52" },      // México
    { label: "+53", value: "53" },      // Cuba
    { label: "+54", value: "54" },      // Argentina
    { label: "+55", value: "55" },      // Brasil
    { label: "+56", value: "56" },      // Chile
    { label: "+57", value: "57" },      // Colombia
    { label: "+58", value: "58" },      // Venezuela
    { label: "+501", value: "501" },    // Belice
    { label: "+502", value: "502" },    // Guatemala
    { label: "+503", value: "503" },    // El Salvador
    { label: "+504", value: "504" },    // Honduras
    { label: "+505", value: "505" },    // Nicaragua
    { label: "+507", value: "507" },    // Panamá
    { label: "+508", value: "508" },    // San Pedro y Miquelón
    { label: "+509", value: "509" },    // Haití
    { label: "+590", value: "590" },    // Guadalupe / San Martín
    { label: "+591", value: "591" },    // Bolivia
    { label: "+592", value: "592" },    // Guyana
    { label: "+593", value: "593" },    // Ecuador
    { label: "+594", value: "594" },    // Guayana Francesa
    { label: "+595", value: "595" },    // Paraguay
    { label: "+596", value: "596" },    // Martinica
    { label: "+597", value: "597" },    // Surinam
    { label: "+598", value: "598" },    // Uruguay
    { label: "+599", value: "599" },    // Curazao / Bonaire / Antillas Neerlandesas
];